/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* Helpers */
import { parseDataToProps } from '~/react/helpers';

const addToCartButtonNodes = document.querySelectorAll('.add-to-cart-button');

if (addToCartButtonNodes.length > 0) {
    import(/* webpackChunkName: "AddToCartPopup" */ '~/react/common/shop').then(({AddToCartPopup: AddToCartPopup}) => {
        [...addToCartButtonNodes].forEach((node) => render(<AddToCartPopup {...parseDataToProps(node.dataset)} />, node));
    });
}
